
import { defineComponent, PropType } from 'vue';
import ItemFile from '@/modules/drive/components/items/ItemFile.vue';
import ItemFolder from '@/modules/drive/components/items/ItemFolder.vue';
import ItemPhoto from '@/modules/drive/components/items/ItemPhoto.vue';
import ItemCase from '@/modules/drive/components/items/ItemCase.vue';
import {
  ICase, IFolder, IMedia, IMixedData,
} from '@/types/interfaces';
import { MEDIA_TYPES, MIXED_DATA_TYPE } from '@/types/enums';
import AppSkeletonMedia from '@/components/skeletons/AppSkeletonMedia.vue';

export default defineComponent({
  components: {
    ItemFile,
    ItemPhoto,
    ItemCase,
    ItemFolder,
    AppSkeletonMedia,
  },
  props: {
    mixedList: { type: Object as () => IMixedData[], required: true },
    movingItem: { type: Object as PropType<IMedia | IFolder | ICase>, required: false },
    loadingMore: { type: Boolean, default: false },
  },
  emits: ['open-folder'],
  setup(props, { emit }) {
    function openFolder(folderId: string) {
      if (props.movingItem?.id === folderId) {
        return;
      }
      emit('open-folder', folderId);
    }

    function block(event: Event) {
      event.stopImmediatePropagation();
    }

    return {
      openFolder,
      block,
      MIXED_DATA_TYPE,
      MEDIA_TYPES,
    };
  },
});
